module.exports = __webpack_public_path__ + "media/images/OPL 22-ff7c9cb7103e5f971cd8f8714b7233af.png";